<!--
 * @Author: your name
 * @Date: 2021-01-14 09:45:28
 * @LastEditTime: 2022-10-27 14:33:38
 * @LastEditors: 逐梦的风很轻 1114532270@qq.com
 * @Description: In User Settings Edit
 * @FilePath: /frontend-user/src/components/ManageCenter/index.vue
-->
<style scoped lang="sass">
.line
  height: 2PX
  width: 20PX
  margin-bottom: 3PX
  border-radius: 2PX
  background: #fff

.manage_center
  height: 45px
  width: 45px
  flex-shrink: 0
  display: flex
  justify-content: center
  align-items: center
</style>

<template lang="pug">
.manage_center(
  @click="manageCenterButton"
)
  .line_container
    .line
    .line
    .line
</template>

<script>
import Vue from 'vue'
import Component from 'vue-class-component'

@Component({
  model: {
    prop: 'showManageCenter',
    event: 'changeManageCenterShow'
  },

  props: {
    // Temporarily useless
    // 暂时无用
    showManageCenter: {
      type: Boolean
    }
  }
})

class ManageCenter extends Vue {
  manageCenterButton() {
    this.$emit('changeManageCenterShow', true)
  }
}

export default ManageCenter
</script>
